module.exports = __webpack_public_path__ + "img/wxCode.e848369b.png";